
<mat-card>
  <mat-card-title>Notifications</mat-card-title>
<!--  <mat-divider></mat-divider>-->


<ng-container *ngFor="let notification of notification_data; let i = index">

  <mat-card style="margin-bottom: 10px">
    <strong>Date:</strong> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  {{notification["date_created"]}}
    <br>
    <strong>Agency:</strong> &nbsp;&nbsp;&nbsp;&nbsp;{{notification["agency_name"]}}
    <br>
    <strong>Account:</strong> &nbsp;&nbsp; {{notification["account_name"]}}
    <br>
    <strong>Message:</strong> &nbsp; {{notification["message"]}}
    <br>
    <button mat-icon-button class="warn-icon-light warn-icon">
      <mat-icon style="cursor: pointer;" (click)="deleteRow(notification['notification_id'], i)">delete</mat-icon>
    </button>

  </mat-card>

</ng-container>

</mat-card>
